import React, { useState, useContext } from "react";
import classes from "./Auth.module.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../image/logo-2.png";
import { auth } from "../../Utility/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { DataContext } from "../../components/DataProvider/DataProvider";
import { Type } from "../../Utility/action.type";
import { ClipLoader } from "react-spinners";
function Auth() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [{ user }, dispatch] = useContext(DataContext);
  const navigate = useNavigate();
  const navStateData = useLocation();
  // console.log(navStateData);

  const authHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    signInWithEmailAndPassword(auth, email, password)
      .then((userInfo) => {
        dispatch({ type: Type.SET_USER, user: userInfo.user });
        setLoading(false);
        navigate(navStateData?.state?.redirect || "/");
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  return (
    <section className={classes.login}>
      <Link to="/">
        <img src={logo} alt="logo" />
      </Link>
      <div className={classes.login_container}>
        <h1>Sign-in</h1>
        {navStateData?.state?.msg && (
          <small
            style={{
              color: "red",
              padding: "5px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {navStateData?.state?.msg}{" "}
          </small>
        )}

        <form action="">
          <div>
            <label htmlFor="email">E-mail</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              id="email"
            />
          </div>
          <div>
            <label htmlFor="password">Password</label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              id="password"
            />
          </div>
          <button
            type="submit"
            onClick={authHandler}
            className={classes.login_signin_button}
          >
            {loading ? <ClipLoader color="#000" size={"15px"} /> : "Sign in"}
          </button>
          <p>
            By signing_in you agree to the AMAZON FAKE CLONE Condition of use &
            Sale. Please see your Privacy Notice, our Cookies Notice and our
            Interest-Based Ads Notice.
          </p>
          <p>
            New to Amazon?{" "}
            <Link to="/auth/create-account">Create an account</Link>
          </p>
          {error && (
            <small style={{ paddingTop: "5px", color: "red" }}>{error}</small>
          )}
        </form>
      </div>
    </section>
  );
}

export default Auth;
